import { render, staticRenderFns } from "./shipmentDetail.vue?vue&type=template&id=2458e4f4&scoped=true"
import script from "./shipmentDetail.vue?vue&type=script&lang=js"
export * from "./shipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./shipmentDetail.vue?vue&type=style&index=0&id=2458e4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458e4f4",
  null
  
)

export default component.exports